import { Breadcrumb } from "@app/shared/components";
import type { Page } from "@core/informative-pages/types";
import { HTML } from "@core/shared/components/HTML";
import { URLS } from "@core/shared/utils";
import { trans } from "@mongez/localization";

export function PageContent({ page }: { page: Page }) {
  return (
    <>
      <div className="container">
        <Breadcrumb
          items={[
            {
              text: trans("home.title"),
              url: URLS.home,
            },
            {
              text: trans(page.title),
              url: URLS[page.name],
            },
          ]}
        />
        <div className="container mx-auto max-w-screen-xl">
          <div className="my-8 flex flex-col gap-4">
            <div className="relative flex items-center py-4">
              <div className="flex-grow border-t border-gray-300 dark:border-gray-600"></div>
              <h2 className="mx-4 flex-shrink text-2xl font-semibold text-gray-900 dark:text-gray-100">
                {page.title}
              </h2>
              <div className="flex-grow border-t border-gray-300 dark:border-gray-600"></div>
            </div>
            <HTML html={page.description} />
          </div>
        </div>
      </div>
    </>
  );
}
